<template>
	<div
		:class="`scrolly-artifact-container stack-horizontal scrolly-artifact-container--${position} ${startAsVisible ? 'visible' : ''}`"
		data-align="center"
		:data-artifact-id="artifact && artifact.id"
		:style="!artifact ? 'display: none' : ''"
	>
		<base-button-rounded
			icon="c-info_2"
			@button-clicked="artifact && openArtifactModal(artifact)"
			icon-color="var(--color-white)"
			class="scrolly-artifact-button"
		/>
		<div class="scrolly-artifact-comic-text generic-small-shadow small-radius">
			<div class="scrolly-artifact-comic-text-content">{{componentString}}</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import utils from '@js/utils.js';
import { componentMixin } from '@js/mixins/componentMixin.js';

export default {
	name: 'InterfaceArtifactInfo',
	mixins: [componentMixin],
	props: {
		artifact: {
			type: Object
		},
		position: {
			type: String,
		},
		customString: {
			type: String,
			default: ''
		},
		startAsVisible: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		componentString() {
			if (!this.artifact) {
				if (this.customString.length) {
					return this.customString
				}else {
					return ""; // MISSING ARTIFACT METADATA";	
				}
			}

			let artifactData = [
				this.artifact.attributes.Autore,
				this.artifact.attributes.titolo,
				// this.artifact.attributes.luogo_conservazione,
				this.artifact.attributes.anno_testo
			]
				.filter(el => el && el.length)

			return artifactData.join(', ')
		},
	},
	mounted() {
		if (!this.artifact && !this.customString.length) console.error("Missing artifact metadata");
	}
};
</script>

<style lang="scss">
	@import '@css/variables.scss';
	
	.scrolly-artifact-container {
		opacity: 1;
		height: 2.875rem;
		// color: var(--scrolly-text-color);
		color: var(--color-black-text);
		position: absolute;
		gap: var(--s1);
		// align-items: flex-start;
		transition-property: opacity;
		transition-duration: .5s;
		z-index: 1;
		
		bottom: var(--section-bottom-margin);

		&.scrolly-artifact-container--left {
			left: var(--section-right-margin);
		}
		&.scrolly-artifact-container--right {
			right: var(--section-right-margin);
		}

		.base-button-rounded {
			width: 2.75rem;
			height: 2.75rem;
			background-color: rgba(0,0,0,0.6);
			opacity: 0;
		}

		.scrolly-artifact-button {
			transition-property: background;
			transition-duration: .5s;

			&:hover {
				background-color: var(--color-black);
			}
		}

		.scrolly-artifact-comic-text {
			opacity: 0;
			display: flex;
			align-items: center;
			height: 100%;
			padding: 0 var(--s1);
			background-color: var(--color-white);
			font-size: 0.875rem;
			overflow: hidden;
			width: 0;
			
		}

		.scrolly-artifact-comic-text-content {
			width: fit-content;
			white-space: nowrap;
		}

		.svg-icon {
			width: 1.25rem;
			height: 1.25rem;
			--svg-icon-color: var(--color-white);
		}
		
		@media (max-width: $breakpoint-sm) {
			position: relative;
			top: unset;
			left: unset !important;
			right: unset !important;
			bottom: unset;
			transform: unset;
			align-self: flex-start;

			.base-button-rounded {
				opacity: 1;
			}
			
  		.scrolly-artifact-comic-text {
				display: none;
			}
		}
	}

	.scrolly-artifact-container.visible .base-button-rounded {
		opacity: 1;
	}

	.scrolly-artifact-container.visible .scrolly-artifact-comic-text {
		width: unset;
		opacity: 1;
	}

</style>
